export type SubscribeResult =
  | { ok: true }
  | { ok: false; error: 'invalid_email' | 'already_subscribed' | 'unknown' };

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export async function subscribe(email: string): Promise<SubscribeResult> {
  if (!EMAIL_RE.test(email)) {
    return { ok: false, error: 'invalid_email' };
  }
  try {
    const res = await fetch('/api/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (res.ok) return { ok: true };
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    if (body.error === 'invalid_email') return { ok: false, error: 'invalid_email' };
    if (body.error === 'already_subscribed') return { ok: false, error: 'already_subscribed' };
    return { ok: false, error: 'unknown' };
  } catch {
    return { ok: false, error: 'unknown' };
  }
}
